export const lightPositiveColors = {
    // TEXT
    positiveText: 'var(--theme-ui-colors-honeyDewText)',
    // BACKGROUND
    positiveBg: 'var(--theme-ui-colors-mint)',
    positiveBgMedium: 'var(--theme-ui-colors-honeyDew)',
    // BORDER
    positiveBorder: 'var(--theme-ui-colors-honeyDew)',
    // ICON
    positiveIcon: 'var(--theme-ui-colors-honeyDew)',
    positiveIconActive: 'var(--theme-ui-colors-cucumber)',
};
export const darkPositiveColors = {
    // TEXT
    positiveText: 'var(--theme-ui-colors-honeyDewText)',
    // BACKGROUND
    positiveBg: 'var(--theme-ui-colors-mint)',
    positiveBgMedium: 'var(--theme-ui-colors-honeyDew)',
    // BORDER
    positiveBorder: 'var(--theme-ui-colors-honeyDew)',
    // ICON
    positiveIcon: 'var(--theme-ui-colors-honeyDew)',
    positiveIconActive: 'var(--theme-ui-colors-cucumber)',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicG9zaXRpdmVDb2xvcnMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdGhlbWUvc2VtYW50aWNDb2xvcnMvcG9zaXRpdmVDb2xvcnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxDQUFDLE1BQU0sbUJBQW1CLEdBQUc7SUFDakMsT0FBTztJQUNQLFlBQVksRUFBRSxxQ0FBcUM7SUFFbkQsYUFBYTtJQUNiLFVBQVUsRUFBRSw2QkFBNkI7SUFDekMsZ0JBQWdCLEVBQUUsaUNBQWlDO0lBRW5ELFNBQVM7SUFDVCxjQUFjLEVBQUUsaUNBQWlDO0lBRWpELE9BQU87SUFDUCxZQUFZLEVBQUUsaUNBQWlDO0lBQy9DLGtCQUFrQixFQUFFLGlDQUFpQztDQUN0RCxDQUFDO0FBRUYsTUFBTSxDQUFDLE1BQU0sa0JBQWtCLEdBQStCO0lBQzVELE9BQU87SUFDUCxZQUFZLEVBQUUscUNBQXFDO0lBRW5ELGFBQWE7SUFDYixVQUFVLEVBQUUsNkJBQTZCO0lBQ3pDLGdCQUFnQixFQUFFLGlDQUFpQztJQUVuRCxTQUFTO0lBQ1QsY0FBYyxFQUFFLGlDQUFpQztJQUVqRCxPQUFPO0lBQ1AsWUFBWSxFQUFFLGlDQUFpQztJQUMvQyxrQkFBa0IsRUFBRSxpQ0FBaUM7Q0FDdEQsQ0FBQyJ9